// extracted by mini-css-extract-plugin
export default {"termsConditions":"_a094cfe2","row":"_039ce41b","col":"_bca132c1","tabs":"_0dfc78a9","tabLabel":"_60610c1e","active":"_1fe65af4"};